import "./profile_checklist.scss";
import { Body } from "@sprout/typography.tsx";
import { SecondaryButton, TertiaryButton } from "@sprout/buttons";
import CheckMarkCircleFilledIcon from "@sprout/icons/check_mark_circle_filled.tsx";
import MinusCircleIcon from "@sprout/icons/minus_circle.tsx";
import CircleIcon from "@sprout/icons/circle.tsx";
import {
  type ChecklistItem,
  type ChecklistStatus,
} from "@components/dashboard/profile/profile_checklist_items.ts";

const StatusIcon = ({ status }: { status: ChecklistStatus }) => {
  if (status === "complete") return <CheckMarkCircleFilledIcon size="md" />;
  if (status === "partial") return <MinusCircleIcon size="md" />;
  return <CircleIcon size="md" />;
};

type RowProps = {
  item: ChecklistItem;
  t: (key: string) => string;
};

const ProfileChecklistRow = ({ item, t }: RowProps) => {
  const { key, status, value } = item;
  const secondLine = status !== "not_started" && value ? value : t(`${key}.description`);

  return (
    <li className="profile_checklist__row">
      <span className="profile_checklist__row-icon">
        <StatusIcon status={status} />
      </span>
      <div className="profile_checklist__row-text">
        <Body medium>{t(`${key}.title`)}</Body>
        <Body metadata secondary>
          {secondLine}
        </Body>
      </div>
      <div className="profile_checklist__row-action">
        {status === "not_started" ? (
          <SecondaryButton size="medium">{t("add")}</SecondaryButton>
        ) : (
          <TertiaryButton secondary>{t("edit")}</TertiaryButton>
        )}
      </div>
    </li>
  );
};

export default ProfileChecklistRow;
